export const NAME_NOT_PROVIDED = '';
export const BUSINESS_UNIT_WFA_TABLE_ID = 'business-unit-wfa-table';
